<div [ngClass]="!!home().theme ? 'bg-white' : 'bg-grey-100'">
    <app-global-contact [contactPerson]="homeContactEmployee()" [hasNgContent]="dealer().hasSales" darker isFirstView>
        <app-home-buttons mobile-buttons />
        <app-home-buttons buttons />

        @if (dealer().hasMobileSellerId) {
            <lib-quick-search
                [listLink]="'/' + dealer().slug + '/fahrzeugbestand'"
                [theme]="home().theme"
                [showQuickFilter]="dealer().hasSales"
            >
                <div class="flex-col gap-4" editable="home.theme" title type="theme">
                    <h1 class="leading-29 text-center text-24 lg:mx-auto lg:text-50 lg:leading-58">
                        Welcher Hyundai darf es sein?
                    </h1>
                    <div
                        class="text-center font-headline text-16 font-medium leading-[22px] lg:text-[23px] lg:leading-28"
                    >
                        {{ dealerLocationHeadline() }}
                    </div>
                </div>
            </lib-quick-search>
        }

        @if (keyCampaign(); as campaign) {
            <a
                ui-m040-c040-promotion-banner
                class="lg:order-2"
                [hyundaiRouterLink]="campaign.detailUrl"
                [class.hidden]="dealerServiceOnly()"
            >
                @if (campaign.content?.minimumShortTitle) {
                    @let minimumShortTitle = campaign.content?.minimumShortTitle ?? '' | footnotes;
                    <span [innerHTML]="minimumShortTitle()"></span>
                } @else {
                    @let teaserHeadline = campaign.teaserHeadline | footnotes;
                    <span [innerHTML]="teaserHeadline()"></span>
                    <br class="lg:hidden" />
                    <span class="hidden lg:inline-block lg:pr-5">.</span>
                    @if (campaign.teaserCopy; as copy) {
                        @let copyFootnotes = copy | footnotes;
                        <span [innerHTML]="copyFootnotes()"></span>
                    }
                }
            </a>
        }

        @if (homeCampaigns().length > 0) {
            <div class="bg-white">
                <div class="inner-page-wrapper flex flex-col items-center gap-24 py-40 md:gap-64">
                    <div
                        class="text-center font-headline text-20 font-medium leading-25 text-black empty:hidden md:text-34 md:leading-41"
                    >
                        <h2 headline>Aktuelle Aktionen</h2>
                    </div>

                    <div class="grid grid-cols-2 gap-x-16 gap-y-24 md:grid-cols-4 lg:gap-[56px]">
                        @for (item of homeCampaignsSliced(); track $index) {
                            <ui-m040-c060-card-small
                                [headline]="item.headline"
                                [image]="item.image"
                                [link]="item.link"
                                isFirstView="false"
                            />
                        }
                    </div>

                    <a ui-m010-c020-icon-link [hyundaiRouterLink]="dealer().pages.campaigns" link>
                        Alle Aktionen anzeigen
                    </a>
                </div>
            </div>
        }
    </app-global-contact>
</div>

@if (keyCampaign(); as campaign) {
    <a
        ui-m040-c040-promotion-banner
        class="lg:order-2"
        [class.hidden]="!dealerServiceOnly()"
        [hyundaiRouterLink]="campaign.detailUrl"
    >
        @if (campaign.content?.minimumShortTitle) {
            @let minimumShortTitle = campaign.content?.minimumShortTitle ?? '' | footnotes;
            <span [innerHTML]="minimumShortTitle()"></span>
        } @else {
            @let teaserHeadline = campaign.teaserHeadline | footnotes;
            <span [innerHTML]="teaserHeadline()"></span>
            <br class="lg:hidden" />
            <span class="hidden lg:inline-block">-</span>
            @if (campaign.teaserCopy; as copy) {
                @let copyFootnotes = copy | footnotes;
                <span [innerHTML]="copyFootnotes"></span>
            }
        }
    </a>
}

<section class="flex flex-col">
    @if (dealer().hasSales) {
        <div class="bg-grey-100 lg:order-1">
            <div class="inner-page-wrapper py-24">
                <app-home-page-models />
            </div>
        </div>
    }
</section>
@defer {
    @if (!homeImageTextContent()?.deleted || dealer().hasMobileSellerId || dealer().hasSales || isLogedIn()) {
        <div
            class="relative flex flex-col bg-accent text-white md:inner-page-wrapper md:flex-row md:items-center md:gap-56 md:bg-white md:pt-40 md:text-black"
        >
            <div class="absolute right-24 top-40 flex justify-end sm:right-12 sm:top-12">
                <div [editable]="'home.imageTextContent'" [type]="'text'"></div>
            </div>
            @if (!homeImageTextContent()?.deleted) {
                @if (homeImageTextContent(); as imageTextContent) {
                    <ui-m000-c010-image
                        class="block h-full flex-1"
                        [classList]="'h-full w-full aspect-[766/432] md:aspect-[4/3] lg:aspect-[686/385] object-cover'"
                        [image]="{
                            image: imageTextContent.image,
                            desktop: { width: 686, height: 385 },
                            tablet: { width: 608, height: 456 },
                            mobile: { width: 766, height: 432 },
                        }"
                        [priority]="false"
                        [alt]="imageTextContent.headline"
                        cover
                    />
                    <div class="flex-1 p-24 pb-32 md:px-0 md:py-12">
                        <h2 class="text-24 leading-30 md:text-34 md:leading-41">{{ imageTextContent.headline }}</h2>
                        @if (imageTextContent.text) {
                            <p class="pb-24 pt-12 text-16 leading-27">{{ imageTextContent.text }}</p>
                        }

                        @if (imageTextContent.link && imageTextContent.linkText) {
                            <a class="white button-secondary md:hidden" [hyundaiRouterLink]="imageTextContent.link">
                                {{ imageTextContent.linkText }}
                            </a>
                            <a class="button-primary hidden w-max md:block" [hyundaiRouterLink]="imageTextContent.link">
                                {{ imageTextContent.linkText }}
                            </a>
                        }
                    </div>
                }
            } @else if (dealer().hasSales || dealer().hasMobileSellerId) {
                <ui-m000-c010-image
                    class="block h-full flex-1"
                    [classList]="'h-full w-full aspect-[766/432] md:aspect-[4/3] lg:aspect-[686/385] object-cover'"
                    [image]="{
                        image: hcmTeaser().image.url,
                        desktop: { width: 686, height: 385 },
                        tablet: { width: 608, height: 456 },
                        mobile: { width: 766, height: 432 },
                    }"
                    [priority]="false"
                    [alt]="hcmTeaser().image.alt || 'Teaser'"
                    cover
                />
                <div class="flex-1 p-24 pb-32 md:px-0 md:py-12">
                    <h2 class="text-24 leading-30 md:text-34 md:leading-41">{{ hcmTeaser().headline }}</h2>
                    <h3 class="text-16 leading-27 md:hidden">bei {{ dealer().name }} in {{ dealer().city }}</h3>
                    <p class="pb-24 pt-12 text-16 leading-27">{{ hcmTeaser().copy }}</p>

                    <a
                        class="contents"
                        [trackingElTarget]="'/' + dealer().slug + '/fahrzeugbestand'"
                        [hyundaiRouterLink]="'/' + dealer().slug + '/fahrzeugbestand'"
                        trackingElType="button"
                        tracking
                        trackingElLabel="Vehicle Market"
                    >
                        <span class="white button-secondary md:hidden">
                            {{ hcmTeaser().ctaLabel }}
                        </span>
                        <span class="button-primary hidden w-max md:block">
                            {{ hcmTeaser().ctaLabel }}
                        </span>
                    </a>
                </div>
            }
        </div>
    }

    @if (homeTeasers().length > 1) {
        <div class="inner-page-wrapper py-24 lg:pb-40 lg:pt-64">
            <ngx-px-carousel-awesome-plus
                class="md:hidden"
                [centered]="false"
                [forceCenter]="false"
                [showControls]="false"
                sliderType="carousel"
            >
                @for (teaser of homeTeasers(); track teaser.id) {
                    <ui-m040-c050-card
                        class="min-w-[230px] px-12"
                        *ngxPxCarouselItem
                        [headline]="teaser.text"
                        [image]="teaser.image"
                        [link]="teaser.detailUrl"
                        [isFirstView]="false"
                    />
                }
            </ngx-px-carousel-awesome-plus>
            <div class="flex justify-end py-10">
                <div [editable]="'home.homeTeaser'" [type]="'text'" homeTeaserEdit></div>
            </div>
            <div class="hidden grid-cols-1 gap-56 md:grid md:grid-cols-3 lg:grid-cols-4">
                @for (teaser of homeTeasers(); track teaser.id) {
                    <ui-m040-c050-card
                        [headline]="teaser.text"
                        [image]="teaser.image"
                        [link]="teaser.detailUrl"
                        isFirstView="false"
                        flushContent
                    />
                }
            </div>
        </div>
    } @else if (homeTeasers().length === 1) {
        @let teaser = homeTeasers()[0];
        <div class="inner-page-wrapper py-24 lg:pb-40 lg:pt-64">
            <div class="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4">
                <ui-m040-c050-card
                    [headline]="teaser.text"
                    [image]="teaser.image"
                    [link]="teaser.detailUrl"
                    isFirstView="false"
                />
            </div>
        </div>
    }

    <div class="bg-grey-100">
        <div class="inner-page-wrapper flex flex-col gap-24 py-40 lg:flex-row lg:justify-center lg:*:flex-1">
            @if (dealer().pages.testDriveForm; as testDriveForm) {
                <app-promotion-link
                    [trackingElTarget]="testDriveForm"
                    [link]="testDriveForm"
                    trackingElLabel="Test Drive"
                    trackingElType="action button"
                    tracking
                    target="_blank"
                >
                    <ng-container head>Erleben Sie Ihren Hyundai!</ng-container>
                    <ng-container sub>Jetzt Probefahrt vereinbaren</ng-container>
                </app-promotion-link>
            }
            @if (dealer().email) {
                <app-promotion-link
                    [trackingElTarget]="dealerServiceMailLink()"
                    [link]="dealerServiceMailLink()"
                    trackingElType="action button"
                    tracking
                    trackingElLabel="Service Request"
                >
                    <ng-container head>Unsere Service-Experten</ng-container>
                    <ng-container sub>Jetzt Servicetermin vereinbaren</ng-container>
                </app-promotion-link>
            }
            @if (dealer().pages.shop; as shop) {
                <app-promotion-link
                    [trackingElTarget]="shop"
                    [link]="shop"
                    [fragment]="'?utm_medium=dealer&bump'"
                    trackingElType="action button"
                    tracking
                    trackingElLabel="Shop"
                >
                    <ng-container head>Teile & Zubehör</ng-container>
                    <ng-container sub>Jetzt Zubehör-Katalog entdecken</ng-container>
                </app-promotion-link>
            }
        </div>
    </div>

    <div class="bg-accent">
        <div
            class="inner-page-wrapper flex flex-col gap-24 py-40 lg:flex-row lg:justify-center lg:gap-[120px] lg:py-64"
        >
            <a
                ui-m010-c020-icon-link
                [trackingElTarget]="dealer().pages.aboutUs + '#' + aboutUsJobsFragment"
                [hyundaiRouterLink]="dealer().pages.aboutUs"
                [fragment]="aboutUsJobsFragment"
                trackingElType="basic link"
                tracking
                trackingElLabel="Carrer"
                inverted
            >
                Karriere
            </a>

            @if (dealer().pages.businessCustomers; as url) {
                <a
                    ui-m010-c020-icon-link
                    [trackingElTarget]="url"
                    [hyundaiRouterLink]="url"
                    trackingElType="basic link"
                    tracking
                    trackingElLabel="Business Customer"
                    inverted
                >
                    Gewerbekunden
                </a>
            }
            <a
                ui-m010-c020-icon-link
                [trackingElTarget]="dealer().pages.aboutUs"
                [hyundaiRouterLink]="dealer().pages.aboutUs"
                trackingElType="basic link"
                tracking
                trackingElLabel="About Us"
                inverted
            >
                Über uns
            </a>
        </div>
    </div>
}
